import { render, staticRenderFns } from "./ViewRegistrationInd.vue?vue&type=template&id=ef8a2434&scoped=true"
import script from "./ViewRegistrationInd.vue?vue&type=script&lang=js"
export * from "./ViewRegistrationInd.vue?vue&type=script&lang=js"
import style0 from "./ViewRegistrationInd.vue?vue&type=style&index=0&id=ef8a2434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8a2434",
  null
  
)

export default component.exports